<template>
	<div>
		<TypographyTitle :level="5">{{ $t(title) }}</TypographyTitle>
		<VerticalLayout>
			<Select
				v-if="showSelect"
				class="width-100"
				v-model:value="gnssSelectedRef"
				:options="gnssOptions"
			/>
			<div class="flex-wrapper">
				<ColorGradient :minValue="minValue" :maxValue="maxValue" :colors="gradientColors" :units="units" />
				<div v-if="help" class="gradient-comment">{{ $t(help) }}</div>
			</div>
		</VerticalLayout>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';
import { TypographyTitle, Select } from 'ant-design-vue';

import MapConsts from '@/components/map/consts/MapConsts';
import { useGnssOptions } from '@/components/stats/useGnssOptions';

import ColorGradient from '@/components/map/ColorGradient.vue';
import VerticalLayout from '@/components/common/VerticalLayout.vue';

export default {
	components: {
		TypographyTitle, Select,
		VerticalLayout, ColorGradient,
	},
	emits: ['update:gnssSelected'],
	props: {
		title: {
			type: String,
			required: true,
		},
		help: {
			type: String,
			required: false,
		},
		gnssSelected: {
			type: String,
			required: false,
		},
		minValue: {
			type: Number,
			required: true,
		},
		maxValue: {
			type: Number,
			required: true,
		},
		units: {
			type: String,
			required: false,
			default: '',
		},
		showSelect: {
			type: Boolean,
			default: true,
			required: false,
		},
	},
	setup(props, { emit }) {
		const gnssSelectedRef = computed({
			get: () => [props.gnssSelected],
			set: value => emit('update:gnssSelected', value[0]),
		})
		const { gnssOptions } = useGnssOptions(false, true);
		return {
			gnssOptions,
			gnssSelectedRef,
			gradientColors: MapConsts.SPRING_COLORS,
		};
	},
}
</script>

<style scoped>
.gradient-comment {
	width: 100px;
}
</style>
